import { render, staticRenderFns } from "./cardOfficeEdit.vue?vue&type=template&id=665277b9&scoped=true"
import script from "./cardOfficeEdit.vue?vue&type=script&lang=js"
export * from "./cardOfficeEdit.vue?vue&type=script&lang=js"
import style0 from "./cardOfficeEdit.vue?vue&type=style&index=0&id=665277b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665277b9",
  null
  
)

export default component.exports